import controller from './categories.controller';
import template from './categories.html';

let categoriesComponent = {
    template,
    controller
};

export default categoriesComponent;
